import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fullIcon from 'assets/img/icons/logistics-full.svg';

export const isFullLogisticValue = value =>
  (() => {
    const normalized = String(value || '').trim().toLowerCase();
    if (!normalized) return false;
    if (['fulfillment', 'full', 'mercado_envios_full', 'meli_facility', 'mercado libre facility'].includes(normalized)) {
      return true;
    }
    return normalized.includes('mercado envíos full') || normalized.includes('mercado envios full');
  })();

const LogisticsLabel = ({ value, label, className = '', iconClassName = '', iconStyle = {} }) => {
  const displayLabel = label || value || '';
  const showFullIcon = isFullLogisticValue(value) || isFullLogisticValue(displayLabel);

  if (!displayLabel && !showFullIcon) {
    return null;
  }

  return (
    <span className={classNames('d-inline-flex align-items-center gap-1', className)}>
      {showFullIcon ? (
        <img
          src={fullIcon}
          alt="Full"
          title={displayLabel || 'Full'}
          className={iconClassName}
          style={{ height: 14, width: 'auto', flexShrink: 0, ...iconStyle }}
        />
      ) : null}
      {displayLabel ? <span>{displayLabel}</span> : null}
    </span>
  );
};

LogisticsLabel.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  iconStyle: PropTypes.object
};

export default LogisticsLabel;
